import type { CategoryPageServerProps } from '@models/categoryMain';

export const CATEGORY_GA_ECOMMERCE_PATH = '카테고리';

export type CategoryGaPageProps = Partial<
  Pick<
    CategoryPageServerProps,
    'pageType' | 'hasAreaDisplay' | 'navigation' | 'navigationPc' | 'shopCds'
  >
>;

/** 카테고리 뎁스 — MO 는 이름 배열, PC 는 {categoryTitle} 배열. 서버/클라이언트 공용 */
export const getCategoryDepth = (initialData?: CategoryGaPageProps): string =>
  (
    initialData?.navigation?.categoryPath ??
    initialData?.navigationPc?.categoryPath?.map(path => path.categoryTitle) ??
    []
  ).join('>');
